function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientInvoiceDeleteApi, clientInvoiceListApi, putInvoice, invalidApply, recallStatus, getSalesman as _getSalesman, uninvoicedListApi } from '@/api/enterprise';
import ClipboardJS from 'clipboard';
import { getInvoiceClassName, getInvoiceText, getInvoiceType } from '@/libs/customer';
import { approveApplyRevokeApi } from '@/api/business';
import { configRuleApproveApi } from '@/api/config';
export default {
  name: 'FinanceList',
  components: {
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    invoiceApply: function invoiceApply() {
      return import('@/components/invoice/invoiceApply');
    },
    invoiceDetails: function invoiceDetails() {
      return import('@/components/invoice/invoiceDetails');
    },
    markDialog: function markDialog() {
      return import('@/views/customer/contract/components/markDialog');
    },
    transferDialog: function transferDialog() {
      return import('@/views/customer/list/components/transferDialog');
    },
    mergeInvoice: function mergeInvoice() {
      return import('@/components/invoice/mergeInvoice');
    },
    invoiceView: function invoiceView() {
      return import('@/views/customer/invoice/components/invoiceView');
    },
    editExamine: function editExamine() {
      return import('@/views/user/examine/components/editExamine');
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    },
    types: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      formBoxConfig: {},
      parameterData: {
        contract_id: '',
        customer_id: '',
        invoice_id: '',
        bill_id: ''
      },
      checkList: [],
      salesmanList: [],
      invoiceData: {},
      tableData: [],
      mergeOpen: false,
      title: '',
      reason: '',
      dialogFormVisible: false,
      dialogVisible: false,
      where: {
        page: 1,
        limit: 15,
        name: '',
        time_field: '',
        time: '',
        status: '',
        types: '',
        way: 1,
        salesman_id: '',
        scope_frame: this.activeName === '2' ? 'all' : 'self'
      },
      withdrawId: '',
      rules: {
        remarks: [{
          required: true,
          message: '请填写撤回理由',
          trigger: 'blur'
        }]
      },
      tooltipTrue: true,
      putInvoiceId: '',
      form: {
        remark: ''
      },
      configMark: {},
      total: 0,
      transferData: {},
      ids: [],
      loading: false,
      buildData: [],
      id: 0,
      search: [{
        form_value: 'select',
        field_name_en: 'time_field',
        field_name: '时间类型',
        data_dict: [{
          value: 'time',
          name: '申请日期'
        }, {
          value: 'bill_date',
          name: '开票日期'
        }]
      }, {
        form_value: 'date_picker',
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time'
      }]
    };
  },
  created: function created() {
    this.where.way = this.types;
    this.getSalesman();
    this.getConfigApprove(0);
  },
  mounted: function mounted() {
    this.getTableData();
  },
  filters: {
    statusTypeFn: function statusTypeFn(val) {
      return getInvoiceText(val);
    },
    bgcFn: function bgcFn(val) {
      return getInvoiceClassName(val);
    },
    titleTypeFn: function titleTypeFn(val) {
      return getInvoiceType(val);
    }
  },
  methods: {
    tabClick: function tabClick() {
      if (this.activeName == 1) {
        this.where.way = 1;
      } else {
        this.where.way = 0;
      }
      this.tooltipTrue = true;
      this.where.page = 1;
      this.tableData = [];
      this.getTableData();
    },
    getConfigApprove: function getConfigApprove(type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return configRuleApproveApi(0);
            case 2:
              result = _context.sent;
              _this.buildData = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // V1.4获取申请开票表单
    handleBuild: function handleBuild(command, val, type) {
      if (type === 'void_invoice_switch') {
        this.parameterData.invoice_id = command.id;
        this.$refs.editExamine.openBox(val, command, type);
      } else {
        this.opneApply(1, '', val);
      }
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      document.documentElement.scrollTop = 0;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    getSalesman: function getSalesman() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getSalesman();
            case 2:
              result = _context2.sent;
              _this2.salesmanList = result.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 发票撤回
    invoiceWithdrawal: function invoiceWithdrawal(val, type) {
      var _this3 = this;
      var id = type === 1 ? val.revoke_id : val.link_id;
      this.$modalSure(this.$t('你确定要撤销申请吗')).then(function () {
        _this3.getApplyRevoke(id);
      });
    },
    getApplyRevoke: function getApplyRevoke(id) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return approveApplyRevokeApi(id);
            case 2:
              _this4.getTableData();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 申请作废
    apply: function apply(val) {
      this.title = '发票申请作废';
      this.reason = '作废原因';
      this.dialogVisible = true;
      this.withdrawId = val.id;
    },
    submitFn: function submitFn() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = {
                remark: _this5.form.remarks
              };
              if (!(_this5.title == '发票申请作废')) {
                _context4.next = 9;
                break;
              }
              data.invalid = 1;
              _context4.next = 5;
              return invalidApply(_this5.withdrawId, data);
            case 5:
              _this5.cancelFn();
              _this5.getTableData();
              _context4.next = 13;
              break;
            case 9:
              _context4.next = 11;
              return recallStatus(_this5.withdrawId, data);
            case 11:
              _this5.cancelFn();
              _this5.getTableData();
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    cancelFn: function cancelFn() {
      this.dialogVisible = false;
      this.form.remarks = '';
    },
    // 作废撤回
    withdraw: function withdraw(val) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$modalSure(_this6.$t('customer.message08'));
            case 2:
              data = {
                invalid: -1
              };
              _context5.next = 5;
              return invalidApply(val.id, data);
            case 5:
              _this6.getTableData();
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this7 = this;
      this.checkList = [];
      this.loading = true;
      clientInvoiceListApi(this.where).then(function (res) {
        _this7.tableData = res.data.list;
        _this7.total = res.data.count;
        _this7.loading = false;
      }).catch(function (error) {
        _this7.loading = false;
      });
    },
    editPaymentRecord: function editPaymentRecord(data) {
      var _this8 = this;
      return new Promise(function (resolve, reject) {
        var val = {
          eid: data.eid,
          invoice_id: data.id,
          withdraw: ''
        };
        uninvoicedListApi(val).then(function (res) {
          if (res.data.length == 0) {
            _this8.mergeOpen = false;
          } else {
            _this8.mergeOpen = true;
          }
          resolve(_this8.mergeOpen);
        });
      });
    },
    // 重新提交
    handleEdit: function handleEdit(row, type) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this9.editPaymentRecord(row).then(function () {
                _this9.formBoxConfig = {
                  title: '申请发票',
                  width: '1000px',
                  edit: true,
                  rowData: row,
                  data: row,
                  type: type
                };
                if (_this9.mergeOpen) {
                  _this9.$refs.mergeInvoice.openBox();
                } else {
                  _this9.formBoxConfig.data = row;
                  _this9.$refs.invoiceApply.openBox(row.id);
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    submit: function submit() {
      var _this10 = this;
      var data = {
        invalid: 1,
        remark: this.form.remark
      };
      this.$refs.remark.validate(function (valid) {
        if (valid) {
          putInvoice(_this10.putInvoiceId, data).then(function (res) {
            _this10.dialogFormVisible = false;
            _this10.form = {};
            _this10.getTableData();
          });
        }
      });
    },
    // 转移
    handleTransfer: function handleTransfer(type) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (this.checkList.length <= 0 && type === 1) {
        this.$message.error(this.$t('customer.placeholder22'));
      } else {
        this.transferData = {
          title: type === 1 ? this.$t('customer.batchtransfersettings') : this.$t('customer.transfersettings'),
          width: '520px',
          type: 3,
          ids: this.checkList
        };
        this.$refs.transferDialog.handleOpen();
      }
    },
    setRemarks: function setRemarks(row) {
      this.configMark = {
        title: this.$t('customer.remarkinformation'),
        width: '480px',
        id: row.id,
        type: 2,
        mark: row.mark
      };
      this.$refs.markDialog.handleOpen();
    },
    // 批量删除
    handleBatchDelete: function handleBatchDelete() {
      var _this11 = this;
      if (this.ids.length <= 0) {
        this.$message.error(this.$t('customer.placeholder22'));
      } else {
        this.$modalSure(this.$t('customer.placeholder78')).then(function () {
          var ids = [];
          _this11.ids.forEach(function (value, index) {
            if (value.status !== 1) {
              ids.push(value.id);
            }
          });
          if (ids.length <= 0) {
            _this11.$message.error(_this11.$t('customer.placeholder67'));
          } else {
            var id = ids.join(',');
            _this11.clientInvoiceDelete(id);
          }
        });
      }
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this12 = this;
      this.$modalSure(this.$t('customer.placeholder23')).then(function () {
        _this12.clientInvoiceDelete(item.id);
      });
    },
    clientInvoiceDelete: function clientInvoiceDelete(id) {
      var _this13 = this;
      clientInvoiceDeleteApi(id).then(function (res) {
        if (_this13.where.page > 1 && _this13.tableData.length <= 1) {
          _this13.where.page--;
        }
        _this13.getTableData();
      });
    },
    // 编辑
    handleCheck: function handleCheck(item) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this14.invoiceData = {
                title: '发票查看',
                width: '1000px',
                data: item
              };
              if (item.link_id == 0) {
                _this14.$refs.invoiceView.openBox(item.link_id);
              } else {
                _this14.$refs.invoiceDetailsView.openBox(item.link_id);
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          page: 1,
          limit: 15,
          name: '',
          time_field: '',
          time: '',
          status: '',
          types: '',
          way: 1,
          salesman_id: '',
          scope_frame: this.activeName === '2' ? 'all' : 'self'
        };
      } else {
        this.where.name = data.keyword_default;
        this.where.time_field = data.time_field;
        this.where.time = data.time;
        this.where.types = data.types;
        this.where.status = data.status;
        this.where.salesman_id = data.salesman_id;
        this.where.scope_frame = data.scope_frame;
      }
      this.where.page = 1;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.ids = val;
    },
    confirmTransfer: function confirmTransfer(e) {
      if (e === 1) {
        this.handleTransfer(1);
      } else if (e === 2) {
        this.handleBatchDelete();
      }
    },
    copy: function copy() {
      var _this15 = this;
      this.$nextTick(function () {
        var clipboard = new ClipboardJS('.copy');
        clipboard.on('success', function () {
          _this15.$message.success(_this15.$t('setting.copytitle'));
          clipboard.destroy();
        });
        _this15.$store.commit('app/SET_CLICK_TAB', false);
      });
    }
  }
};